import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    q: "Do you accept insurance?",
    a: "DLG is an out-of-network provider. I can provide monthly superbills you may submit to your insurance for possible reimbursement. Please contact your carrier to verify out-of-network mental-health benefits before your first session.",
  },
  {
    q: "How long is a session, and what does it cost?",
    a: "Standard sessions are 50 minutes. Extended sessions (75–90 min) are available for couples and family work. Fees are shared transparently during our free 15-minute consultation.",
  },
  {
    q: "Is telehealth as effective as in-person therapy?",
    a: "Research consistently shows telehealth is comparably effective for most concerns — and often more sustainable for busy couples, parents, and Californians outside major metros. Sessions are on a secure, HIPAA-compliant platform.",
  },
  {
    q: "Are you licensed to see clients outside California?",
    a: "No. As a California-licensed MFT, I can only work with clients physically located in California at the time of session. This includes short trips out of state.",
  },
  {
    q: "What if I'm in crisis?",
    a: "This form and voicemail are not monitored for emergencies. If you are in crisis, please call or text 988 (Suicide & Crisis Lifeline) or go to your nearest emergency room.",
  },
];

const ease = [0.16, 1, 0.3, 1];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq"
      className="relative w-full py-28 sm:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10">
        <div className="flex items-baseline justify-between border-b border-[#D5D1C9] pb-6">
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#5C5C59]">
            (Ch. V) — Practicalities
          </span>
          <span className="font-serif-display italic text-[#5C5C59]">faq</span>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-10">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, ease }}
            className="col-span-12 md:col-span-5 font-serif-display font-light tracking-tighter leading-[1] text-5xl sm:text-6xl"
          >
            The <em className="italic">questions</em> people ask before the first call.
          </motion.h2>

          <div className="col-span-12 md:col-span-7" data-testid="faq-list">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#D5D1C9]"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-6 text-left font-serif-display text-xl sm:text-2xl text-[#1A1A18] hover:no-underline"
                  >
                    <span className="flex items-baseline gap-6">
                      <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#5C5C59]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8 pl-14 font-sans-ui text-[15px] leading-relaxed text-[#5C5C59]">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
